import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MapPanelStatus } from "./map-panel-status";

export const InspectorsPanelAnimations = {
  mapPanelTrigger: trigger("mapPanel", [
    state(
      MapPanelStatus.CLOSED,
      style({
        width: "0%",
      }),
    ),
    state(
      MapPanelStatus.OPENED,
      style({
        width: "60%",
      }),
    ),
    transition("* => *", animate(250)),
  ]),
};
